import { IEmailModel } from 'Modules/Communication/Email/shared/models/Email'
import {
  ILoadingMessageRecipient,
  IMessageReciept,
  IMessageRecieptRecipient,
  ISendSmsSettings,
  SendMessageStateEnum,
} from 'shared/models/Message'

const initialState = {
  message: null as unknown as IEmailModel,
  messageId: null as string | null,
  state: null as SendMessageStateEnum | null,
  loading: false,
  processing: false,
  isDraftUpdated: false,
  isDraftUpdating: false,
  isEditDraft: false,
  isCollapsed: false,
  error: null as string | null,
  reciept: {
    data: null as IMessageReciept | null,
    loading: false,
    processing: false,
    createContact: null as IMessageRecieptRecipient | null,
    error: null as string | null,
    messageId: null as string | null,
  },
  recipientLoadingQueue: [] as ILoadingMessageRecipient[],
}

export const initialSendEmailState = {
  ...initialState,
  savingAttachments: false,
}

export const initialSendSmsState = {
  ...initialState,
  settings: {
    data: null as ISendSmsSettings | null,
    loading: true,
    error: null as string | null,
  },
}
